/**
 * @generated SignedSource<<885a27c54d7500501eef4e04e6ba3fb2>>
 * @relayHash 12f44a09d0c20a1af0e3999bad35cb1b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 497edb9e81fd65ef7a41b7536d40bfbb59a6d6907f2d3365cfe1404fd4030fcf

import type { ConcreteRequest } from 'relay-runtime';
export type preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$variables = {
  contentId: string;
  smartLinksFromDraft?: boolean | null;
};
export type preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$data = {
  readonly confluence_contentSmartLinksForDraft?: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly canView: boolean;
      readonly emojiTitle: string | null;
      readonly iconUrl: string | null;
      readonly product: string | null;
      readonly resolved: boolean;
      readonly resourceType: string | null;
      readonly statusAppearance: string | null;
      readonly statusText: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly url: string;
    } | null> | null;
  } | null;
  readonly contentSmartLinks?: {
    readonly nodes: ReadonlyArray<{
      readonly __typename: string;
      readonly canView: boolean;
      readonly emojiTitle: string | null;
      readonly iconUrl: string | null;
      readonly product: string | null;
      readonly resolved: boolean;
      readonly resourceType: string | null;
      readonly statusAppearance: string | null;
      readonly statusText: string | null;
      readonly subType: string | null;
      readonly title: string | null;
      readonly url: string;
    } | null> | null;
  } | null;
};
export type preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery = {
  response: preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$data;
  variables: preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "smartLinksFromDraft"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  }
],
v2 = [
  {
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "ScalarField",
        "name": "url"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      },
      {
        "kind": "ScalarField",
        "name": "emojiTitle"
      },
      {
        "kind": "ScalarField",
        "name": "canView"
      },
      {
        "kind": "ScalarField",
        "name": "product"
      },
      {
        "kind": "ScalarField",
        "name": "resourceType"
      },
      {
        "kind": "ScalarField",
        "name": "subType"
      },
      {
        "kind": "ScalarField",
        "name": "iconUrl"
      },
      {
        "kind": "ScalarField",
        "name": "resolved"
      },
      {
        "kind": "ScalarField",
        "name": "statusText"
      },
      {
        "kind": "ScalarField",
        "name": "statusAppearance"
      }
    ]
  }
],
v3 = [
  {
    "condition": "smartLinksFromDraft",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedSmartLinkList",
        "kind": "LinkedField",
        "name": "contentSmartLinks",
        "plural": false,
        "selections": (v2/*: any*/)
      }
    ]
  },
  {
    "condition": "smartLinksFromDraft",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "PaginatedSmartLinkList",
        "kind": "LinkedField",
        "name": "confluence_contentSmartLinksForDraft",
        "plural": false,
        "selections": (v2/*: any*/)
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "12f44a09d0c20a1af0e3999bad35cb1b",
    "id": "497edb9e81fd65ef7a41b7536d40bfbb59a6d6907f2d3365cfe1404fd4030fcf",
    "metadata": {},
    "name": "preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery",
    "operationKind": "query",
    "text": "query preloadContentSmartLinksViewPageExtensionsAndRendererAssetsQuery($contentId:ID!,$smartLinksFromDraft:Boolean=false){contentSmartLinks(id:$contentId)@skip(if:$smartLinksFromDraft){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved,statusText,statusAppearance}},confluence_contentSmartLinksForDraft(id:$contentId)@include(if:$smartLinksFromDraft){nodes{__typename,url,title,emojiTitle,canView,product,resourceType,subType,iconUrl,resolved,statusText,statusAppearance}}}"
  }
};
})();

(node as any).hash = "0f70fb226e9d3bbec8e2c784f91a3086";

export default node;
